/*
 * @Author: cc
 * @Date: 2019-12-21 21:31:55
 * @LastEditTime: 2022-01-20 15:55:37
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editListPart\editListButtons\editListButtons.js
 * @Description:新媒体渠道列表指令
 */
angular.module('editListButtonsModule', []).directive('editListButtons', [
    '$state',
    'editcenterRightsService',
    'newMediaService',
    'trsspliceString',
    'messagePublishService',
    'editingCenterService',
    function($state, editcenterRightsService, newMediaService, trsspliceString, messagePublishService, editingCenterService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editListPart/editListButtons/editListButtons.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.buttonList = {
                        add: ['add'],
                        edit: ['edit'],
                        songshen: ['songshen'],
                        qianfa: ['qianfa'],
                        bianjiFgd: ['bianjiFgd'],
                        feigao: ['feigao'],
                        export: ['export'],
                        mail: ['mail'],
                        xiuding: ['xiuding'],
                        transmit: ['transmit']
                    };
                    $scope.checkList = {};
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    initBtnRights();
                }

                /**
                 * [initBtnRights description]初始化按钮权限
                 * @return  {[type]}  [return description]
                 */
                function initBtnRights() {
                    editcenterRightsService
                        .initNewMediaBtn({
                            methodname: 'queryOperKeyOfKuaiBao',
                            Classify: $scope.parentStatus.Classify,
                            AccountId: $state.params.account,
                        })
                        .then(function(rights) {
                            $scope.parentStatus.btnRights = rights;
                            buttonListCheck();
                        });
                }

                /**
                 * 处理按钮权限
                 * @return  {[type]}  [return description]
                 */
                function buttonListCheck() {
                    // Object.keys 为了得出对象key的集合
                    let getCheckList = Object.keys($scope.parentStatus.btnRights);
                    let checkList = Object.keys($scope.buttonList);
                    for (let i = 0; i < getCheckList.length; i++) {
                        for (let l = 0; l < checkList.length; l++) {
                            let check = false;
                            for (let b = 0; b < $scope.buttonList[checkList[l]].length; b++) {
                                let checkKey = `${$scope.parentStatus.buttonCheck.name}.${$scope.parentStatus.buttonCheck.type}.${
                                    $scope.buttonList[checkList[l]][b]
                                }`;
                                if (checkKey === getCheckList[i]) {
                                    $scope.checkList[checkList[l]] = true;
                                    check = true;
                                    break;
                                }
                            }
                            if (check) {
                                break;
                            }
                        }
                    }
                    $scope.parentStatus.checkList = $scope.checkList;
                    // 这段代码可以留着作为理解，上面的代理可以进行跳出循环
                    // Object.keys($scope.parentStatus.btnRights).forEach((key) => {
                    //     Object.keys($scope.buttonList).forEach((lastKey) => {
                    //         $scope.buttonList[lastKey].forEach((item) => {
                    //             const checkKey = `${$scope.parentStatus.buttonCheck.name}.${$scope.parentStatus.buttonCheck.type}.${item}`;
                    //             if (checkKey === key){
                    //                 $scope.checkList[lastKey] = true;
                    //             }
                    //         });
                    //     });
                    // });
                }

                /**
                 * [trial description]送审操作
                 * @return {[type]} [description]
                 */
                $scope.trial = function() {
                    newMediaService.trial(
                        $scope, $scope.parentStatus.typeConst.trial
                    );
                };

                /**
                 * [trial description]送审操作
                 * @return {[type]} [description]
                 */
                $scope.requestData = function() {
                    messagePublishService.publish('refresh', true);
                };

                /**
                 * [sign description]稿件签发
                 * @return {[type]} [description]
                 */
                $scope.sign = function() {
                    $scope.loadingPromise = newMediaService.sign($scope, $scope.parentStatus.typeConst.sign, function(params, selectedArray) {
                        params.objectids = selectedArray.map(function(value, index) {
                            return value.DOC.METADATAID;
                        }).join(',');
                    }
                    );
                };

                /**
                 * [abandonDraft description]废稿函数
                 * @return {[type]}      [description]
                 */
                $scope.waste = function() {
                    $scope.loadingPromise = newMediaService.delete($scope, $scope.parentStatus.typeConst.waste);
                };

                /**
                 * [exportDraft description:导出稿件]
                 * @return  {[type]}         [return description]
                 */
                $scope.exportDraft = function() {
                    var params = {
                        serviceid: 'mlf_kuaibaoper',
                        methodname: 'daiBianExportWordFile',
                        objectids: trsspliceString.spliceString($scope.data.selectedArray, 'KUAIBAOARTICLEID', ','),
                        accountId: $state.params.account,
                    };
                    newMediaService.export(angular.extend(params, $scope.parentStatus.typeConst.export), $scope.data.selectedArray);
                };

                /**
                 * [outSending description：外发]
                 * @return  {[type]}         [return description]
                 */
                $scope.outSource = function() {
                    $scope.loadingPromise = newMediaService.outsource(
                        angular.extend(
                            {
                                qieHaoArticleIds: trsspliceString.spliceString($scope.data.selectedArray, 'KUAIBAOARTICLEID', ','),
                                accountId: $state.params.account,
                                MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'KUAIBAOARTICLEID', ',')
                            },
                            $scope.parentStatus.typeConst.outsource
                        ),
                        $scope.data.selectedArray
                    );
                };

                /**
                 * [revise description] 修订方法
                 * @return  {[type]}  [return description]
                 */
                $scope.revise = function() {
                    var params = {
                        DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                        MediaType: $scope.parentStatus.mediaType,
                    };
                    newMediaService.revise($scope, params);
                };

                /**
                 * [revise description] 发稿单
                 * @return  {[type]}  [return description]
                 */
                $scope.draftlist = function() {
                    newMediaService.draftlist($scope, $scope.parentStatus.typeConst.draftListDB, $scope.parentStatus.typeConst.draftListQuery);
                };

                /**
                 * [distribution description]多元分发
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.distribution = function() {
                    $scope.parentStatus.isEssearch = false;
                    newMediaService.distribution($scope.data.selectedArray);
                };
            },
        };
    },
]);
